import { Box, Typography } from "@mui/material";

type Props = {
  currentBlock: any;
};

const SubTitleField = ({ currentBlock }: Props) => {
  const label = currentBlock?.label;

  return (
    <Box sx={{ textAlign: "center" }}>
      <Typography
        variant="h3"
        sx={{
          fontWeight: "regular",
          color: "text.primary",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};
export default SubTitleField;
